export const NEWS_LS_KEY = 'resurgo-news-v1';

export const CATEGORIES = [
  { id: 'legal',    label: 'قانوني وتشريعي', color: 'bg-purple-100 text-purple-700 border-purple-200' },
  { id: 'tax',      label: 'ضريبة ورسوم',    color: 'bg-rose-100   text-rose-700   border-rose-200'   },
  { id: 'zoning',   label: 'مخططات ومناطق',  color: 'bg-teal-100   text-teal-700   border-teal-200'   },
  { id: 'diaspora', label: 'مغتربون وعائدون', color: 'bg-blue-100   text-blue-700   border-blue-200'   },
  { id: 'market',   label: 'السوق العقاري',   color: 'bg-green-100  text-green-700  border-green-200'  },
];

export const URGENCY = {
  urgent:  { label: 'عاجل',   color: 'bg-red-500    text-white', dot: 'bg-red-500'    },
  high:    { label: 'مهم',    color: 'bg-amber-500  text-white', dot: 'bg-amber-500'  },
  info:    { label: 'معلومة', color: 'bg-navy/70    text-white', dot: 'bg-navy/50'    },
};

export const SOURCES = {
  finance:  'وزارة المالية',
  justice:  'وزارة العدل',
  cabinet:  'مجلس الوزراء',
  courts:   'المحاكم',
  resurgo:  'فريق RESURGO',
  research: 'فريق الأبحاث',
};

export function getCategoryLabel(id) {
  return CATEGORIES.find(c => c.id === id)?.label ?? id;
}
export function getCategoryColor(id) {
  return CATEGORIES.find(c => c.id === id)?.color ?? 'bg-navy/10 text-navy border-navy/20';
}
export function calcReadTime(body) {
  return Math.max(1, Math.ceil((body || '').split(/\s+/).length / 200));
}

export const INITIAL_NEWS = [
  {
    id: 1, cat: 'tax', urgency: 'urgent', source: 'finance', featured: true, status: 'published',
    impacts: ['بيع', 'إيجار'],
    title: 'إصلاح ضريبة البيوع العقارية 2025 — القيمة العقدية الرضائية',
    summary: 'أعلنت وزارة المالية اعتماد القيمة العقدية الرضائية بدلاً من القيمة الرائجة أساساً للتقدير الضريبي. سكني 1.5% · تجاري 4% · أرض داخل مخطط 3% · خارج مخطط 2%.',
    body: `صدر في تموز-آب 2025 قرار وزارة المالية المتعلق بإصلاح منظومة ضريبة البيوع العقارية، إذ أصبح التقدير يستند إلى القيمة العقدية الرضائية التي يُصرّح عنها الطرفان بدلاً من القيمة الرائجة التي كانت تُحددها الدائرة المالية من طرف واحد.

الأسعار المعتمدة:
• سكني: 1.5% من قيمة العقد
• تجاري (محل، مكتب، مستودع): 4%
• أرض داخل المخطط التنظيمي: 3%
• أرض خارج المخطط: 2%

الإعفاءات:
• هبة/إعارة عائلية (أصول وفروع وأزواج): معفى 100%
• نكول عن البيع: معفى 100% بشرط إقرار خطي مشترك

ملاحظة هامة: الدائرة المالية تُجري تدقيقاً عشوائياً — مخالفة التصريح تُوجب غرامة مثلي فرق الضريبة.`,
    author: 'فريق RESURGO', date: '2025-08-01', readTime: 4,
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80',
    tags: ['ضريبة البيوع', 'إصلاح 2025', 'وزارة المالية'],
    createdAt: 1753920000000, updatedAt: 1753920000000,
  },
  {
    id: 2, cat: 'legal', urgency: 'urgent', source: 'cabinet', featured: false, status: 'published',
    impacts: ['بيع', 'تسجيل'],
    title: 'مرسوم تسجيل العقارات رقمياً — التطبيق يوليو 2025',
    summary: 'يُلزم المرسوم الجديد بتسجيل جميع عقود نقل الملكية إلكترونياً عبر منصة "إنجز" الحكومية. توقيع رقمي إلزامي + ربط السجل العقاري بقاعدة بيانات مركزية.',
    body: `أصدر مجلس الوزراء مرسوماً تشريعياً يُلزم جميع الجهات الموثّقة بإتمام إجراءات نقل الملكية إلكترونياً عبر منصة "إنجز" الحكومية اعتباراً من يوليو 2025.

يُشترط وفق المرسوم:
• توقيع رقمي موثّق من الجهة المختصة على كل وثيقة ملكية
• ربط السجل العقاري بقاعدة بيانات وطنية مركزية
• إتاحة الاستعلام الفوري عن أي عقار

فترة انتقالية: 6 أشهر لإتمام رقمنة السجلات القديمة.`,
    author: 'محرر قانوني', date: '2025-05-10', readTime: 6,
    image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=800&q=80',
    tags: ['تشريع', 'تسجيل رقمي', 'مجلس الوزراء'],
    createdAt: 1746835200000, updatedAt: 1746835200000,
  },
  {
    id: 3, cat: 'diaspora', urgency: 'high', source: 'justice', featured: false, status: 'published',
    impacts: ['وكالة', 'إرث', 'بيع'],
    title: 'تحديث إجراءات الوكالات العقارية للمغتربين — متطلبات 2025',
    summary: 'حدّدت وزارة العدل اشتراطات جديدة لتوثيق الوكالات العقارية الصادرة من الخارج. التصديق القنصلي + التصديق بالأبوستيل + ترجمة قانونية معتمدة.',
    body: `بناءً على تعميم وزارة العدل الصادر في 2025، يجب أن تستوفي وكالات بيع العقارات الصادرة خارج سوريا الشروط التالية:

1. توثيق الوكالة لدى كاتب العدل المحلي في بلد الإقامة
2. التصديق من وزارة خارجية البلد المضيف
3. التصديق من السفارة/القنصلية السورية المختصة
4. ختم الأبوستيل (للدول الموقّعة على اتفاقية لاهاي 1961)
5. ترجمة قانونية معتمدة إلى العربية
6. التصديق من وزارة الخارجية السورية في دمشق

الرسوم القنصلية المعتمدة (السفارة السورية بالرياض):
• وكالة بيع: 100$
• تصديق وثيقة: 50$
• وكالة عزل: 100$`,
    author: 'فريق التخليص', date: '2025-05-08', readTime: 5,
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80',
    tags: ['مغتربون', 'وكالة عقارية', 'تصديق'],
    createdAt: 1746662400000, updatedAt: 1746662400000,
  },
  {
    id: 4, cat: 'zoning', urgency: 'high', source: 'cabinet', featured: false, status: 'published',
    impacts: ['بيع', 'بناء'],
    title: 'تعديلات المخطط التنظيمي لمنطقة المزة — دمشق 2025',
    summary: 'أقرّ مجلس الوزراء تعديلات على المخطط التنظيمي لمنطقة المزة تشمل تغيير تصنيف بعض القطع من سكني إلى تجاري واستحداث مناطق استثمارية جديدة.',
    body: `أقرّ مجلس الوزراء في اجتماعه الأخير تعديلات جوهرية على المخطط التنظيمي لمنطقة المزة في دمشق، تتضمن:

• تحويل قطع في المزة الغربية من التصنيف السكني A إلى تجاري B
• استحداث منطقة استثمارية مختلطة (سكني + تجاري) في المحور الرئيسي
• رفع معامل الاستثمار (FAR) من 2.5 إلى 3.2 في المناطق المحددة
• اشتراط مواقف سيارات بمعدل 1 موقف لكل 75م² للتجاري

تأثير على المالكين: قد تتغير قيمة العقارات المعاد تصنيفها بنسبة 20-35%. يُنصح بمراجعة الدائرة المالية قبل أي معاملة بيع.`,
    author: 'فريق الأبحاث', date: '2025-05-06', readTime: 4,
    image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&q=80',
    tags: ['مخطط تنظيمي', 'المزة', 'دمشق'],
    createdAt: 1746489600000, updatedAt: 1746489600000,
  },
  {
    id: 5, cat: 'market', urgency: 'info', source: 'resurgo', featured: false, status: 'published',
    impacts: ['بيع', 'إيجار'],
    title: 'أسعار العقارات في دمشق ترتفع 12% — الربع الأول 2025',
    summary: 'ارتفع متوسط سعر المتر في دمشق إلى 1,450$ مقابل 1,295$ في 2024. المزة الغربية +15.2% · قدسيا +13.7% · برزة +11.4%.',
    body: `شهد سوق العقارات السوري خلال الربع الأول من 2025 ارتفاعاً في متوسط أسعار الشقق السكنية في دمشق بنسبة 12% مقارنةً بالفترة ذاتها من 2024.

متوسط سعر المتر المربع في دمشق: 1,450$ (مقابل 1,295$ في 2024)

أعلى المناطق ارتفاعاً:
• المزة الغربية: +15.2%
• قدسيا: +13.7%
• برزة: +11.4%

الأسباب: تصاعد الطلب من المغتربين العائدين + شحّ الوحدات الجاهزة في الأحياء المركزية.`,
    author: 'فريق RESURGO', date: '2025-05-11', readTime: 4,
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=80',
    tags: ['أسعار', 'دمشق', '2025'],
    createdAt: 1746921600000, updatedAt: 1746921600000,
  },
  {
    id: 6, cat: 'diaspora', urgency: 'high', source: 'justice', featured: false, status: 'published',
    impacts: ['إرث', 'بيع'],
    title: 'حصر الإرث عن بُعد — الإجراءات الجديدة للمقيمين خارج سوريا',
    summary: 'تُتيح التعديلات الجديدة للورثة المقيمين خارج سوريا استكمال إجراءات حصر الإرث عبر وكيل قانوني معتمد دون الحضور الشخصي. شروط وضوابط محددة.',
    body: `استناداً إلى تعديلات قانون الأحوال الشخصية لعام 2025، باتت المحاكم تقبل استكمال إجراءات حصر الإرث بحضور وكيل قانوني بدلاً من الورثة أنفسهم، وفق الضوابط التالية:

الشروط:
• وكالة قانونية خاصة موثّقة من السفارة السورية + تصديق أبوستيل
• إثبات درجة القرابة عبر وثائق الأحوال المدنية مصادق عليها
• شهادة وفاة المورّث موثّقة رسمياً

الوثائق المطلوبة من كل وارث:
• صورة عن جواز السفر موثّقة
• إقرار عدم الاعتراض على توزيع التركة (اختياري يُسرّع الإجراء)

مدة الإجراء: 30-90 يوم حسب تعقيد التركة وعدد الورثة.`,
    author: 'فريق التخليص', date: '2025-04-28', readTime: 6,
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
    tags: ['حصر إرث', 'مغتربون', 'محاكم'],
    createdAt: 1745798400000, updatedAt: 1745798400000,
  },
];
